// Mock data for Complise India redesign

export const LOGO_URL = 'https://customer-assets-v7afamib.emergentagent.net/job_complise-new/artifacts/4gkarw8a_image.png';

export const HERO_IMAGE = 'https://images.pexels.com/photos/5816300/pexels-photo-5816300.jpeg';
export const ABOUT_IMAGE_1 = '/images/about-compliance-team.png';
export const MISSION_VALUES_IMAGE = '/images/mission-values-team.png';
export const HANDSHAKE_IMAGE = 'https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1400&q=80';

export const stats = [
  { value: '8+', label: 'Years of regulatory execution' },
  { value: '30+', label: 'Industries served' },
  { value: '100%', label: 'Timeline-focused delivery' },
  { value: '6+', label: 'Global partnerships' },
  { value: '20+', label: 'Knowledge partners' },
];

export const approach = [
  {
    icon: 'Compass',
    title: 'Approval route mapping',
    desc: 'We identify the right authority, certification path, testing requirement and filing sequence.',
    variant: 'light',
  },
  {
    icon: 'FileCheck2',
    title: 'Document control & filing',
    desc: 'We organize technical files, labels, authorizations and portal inputs before submission.',
    variant: 'primary',
  },
  {
    icon: 'ShieldCheck',
    title: 'Certification & renewals',
    desc: 'Managed AMC-style compliance ownership — tracking, renewals, surveillance and updates.',
    variant: 'dark',
  },
];

const SVC = 'https://compliseindia.com/assets/services';

export const services = [
  { id: '01', code: 'BIS', name: 'Bureau of Indian Standards', tag: 'ISI / CRS / Hallmark / FMCS', desc: 'Product certification, ISI, FMCS, Hallmark and CRS pathways.', logo: `${SVC}/bis.png`, href: '/bureau-of-indian-standards-bis' },
  { id: '02', code: 'BEE', name: 'Bureau of Energy Efficiency', tag: 'BEE Certification', desc: 'Energy efficiency registration and labelling.', logo: `${SVC}/bee.png`, href: '/bureau-of-energy-efficiency-bee' },
  { id: '03', code: 'WPC', name: 'Wireless Planning & Coordination', tag: 'WPC Approval', desc: 'ETA, wireless approvals and RF compliance.', logo: `${SVC}/wpc.png`, href: '/wireless-planning-coordination-wpc' },
  { id: '04', code: 'TEC', name: 'Telecommunication Engineering Centre', tag: 'MTCTE / TSEC / NCCS', desc: 'Telecom equipment approvals and MTCTE coordination.', logo: `${SVC}/tec.png`, href: '/telecommunication-engineering-centre-tec' },
  { id: '05', code: 'STQC', name: 'Standardisation Testing & Quality Certification', tag: 'STQC Certification', desc: 'Technology, device and quality certification workflows.', logo: `${SVC}/stqc.png`, href: '/standardisation-testing-quality-certification-stqc' },
  { id: '06', code: 'LMPC', name: 'Consumer Affairs / Legal Metrology', tag: 'Legal Metrology', desc: 'Legal Metrology and packaged commodity compliance.', logo: `${SVC}/consumeraffair.png`, href: '/consumer-affairs-legal-metrology' },
  { id: '07', code: 'CDSCO', name: 'Central Drugs Standard Control Org', tag: 'Medical / Cosmetic License', desc: 'Medical device registration and cosmetic licensing.', logo: `${SVC}/cdsco.png`, href: '/central-drugs-standard-control-organization-cdsco' },
  { id: '08', code: 'FSSAI', name: 'Food Safety & Standards Authority', tag: 'FSSAI Approval', desc: 'Food licensing, import clearance and product approvals.', logo: `${SVC}/fssai.png`, href: '/food-safety-standards-authority-india-fssai' },
  { id: '09', code: 'DOT', name: 'Department of Telecommunication', tag: 'TAC-IMEI', desc: 'TAC and IMEI registration support for devices.', logo: `${SVC}/dot.png`, href: '/department-of-telecommunication-dot' },
  { id: '10', code: 'PESO', name: 'Petroleum & Explosives Safety Org', tag: 'PESO Certification', desc: 'Petroleum, gas cylinder and storage safety approvals.', logo: `${SVC}/peso.png`, href: '/petroleum-explosives-safety-organization-peso' },
  { id: '11', code: 'DGFT', name: 'Directorate General of Foreign Trade', tag: 'DGFT Approval', desc: 'Import-export authorization and trade compliance.', logo: `${SVC}/dgft.png`, href: '/directorate-general-foreign-trade-dgft' },
  { id: '12', code: 'ARAI', name: 'Automotive Research Association of India', tag: 'ARAI Approval', desc: 'Automotive product testing and approval coordination.', logo: `${SVC}/arai.png`, href: '/automotive-research-association-india-arai' },
  { id: '13', code: 'B&L', name: 'Business & Legal Compliance', tag: 'GST / IP / IEC / SCOMET', desc: 'Company registration, GST, taxation, IP and ongoing support.', logo: `${SVC}/business-legal.svg`, href: '/business-legal-compliance' },
  { id: '14', code: 'GeM', name: 'Government e Marketplace', tag: 'Registration / Account Management', desc: 'Registration, vendor assessment, catalogue, tender, order and account management support.', logo: '/assets/services/gem-logo.jpg', href: '/gem-registration' },
];

export const methodology = [
  { step: '01', title: 'Initial Advisory', icon: 'MessageSquare', desc: 'We understand your business, product category, regulatory exposure and current compliance status.' },
  { step: '02', title: 'Documentation', icon: 'FileText', desc: 'We prepare accurate, audit-ready files, technical records, labels and application inputs.' },
  { step: '03', title: 'Testing & Inspection', icon: 'FlaskConical', desc: 'We coordinate sample testing, laboratory communication and inspection readiness.' },
  { step: '04', title: 'Application Submission', icon: 'Send', desc: 'We submit applications, handle authority communication and track query closure.' },
  { step: '05', title: 'Certification & Maintenance', icon: 'BadgeCheck', desc: 'We support certification closure, renewals, surveillance, updates and ongoing compliance.' },
];

export const whyChoose = [
  { id: '01', title: 'Extensive Clientele', icon: 'Users', desc: 'Experience across product lines, business models, manufacturers, importers and regulated sectors.' },
  { id: '02', title: 'Experience & Expertise', icon: 'Award', desc: 'Practical knowledge of approval routes, standards, documentation, testing and authority workflows.' },
  { id: '03', title: 'Comprehensive Services', icon: 'LayoutGrid', desc: 'One coordinated partner for certification, licensing, testing, renewals, portals and AMC operations.' },
  { id: '04', title: 'Dedicated Support', icon: 'Headphones', desc: 'Clear coordination with internal teams, vendors, manufacturers, labs and government authorities.' },
  { id: '05', title: 'Timely Delivery', icon: 'Clock', desc: 'Structured tracking helps reduce avoidable delays, missed dependencies and renewal surprises.' },
  { id: '06', title: 'Global Reach', icon: 'Globe2', desc: 'Support for Indian regulatory access with coordination for overseas factories and global brands.' },
];

export const industries = [
  { id: '01', name: 'Telecom', icon: 'Radio', desc: 'TEC, WPC, DOT and network equipment routes.' },
  { id: '02', name: 'IT', icon: 'MonitorCog', desc: 'CRS, BEE and product safety documentation.' },
  { id: '03', name: 'Electronics', icon: 'Cpu', desc: 'CRS, WPC, BEE, LMPC and import compliance.' },
  { id: '04', name: 'Electrical', icon: 'Zap', desc: 'BIS, BEE, Scheme-X and safety standards.' },
  { id: '05', name: 'Medical Devices', icon: 'HeartPulse', desc: 'CDSCO registration, import and quality records.' },
  { id: '06', name: 'Agriculture', icon: 'Wheat', desc: 'Product, packaging and import-export compliance.' },
  { id: '07', name: 'Cement', icon: 'Blocks', desc: 'ISI certification and factory inspection readiness.' },
  { id: '08', name: 'Textile', icon: 'Shirt', desc: 'QCO, labeling, packaging and market access.' },
  { id: '09', name: 'Aviation', icon: 'Plane', desc: 'Specialized product, import and technical coordination.' },
  { id: '10', name: 'Safety Products', icon: 'HardHat', desc: 'ISI, testing, marking and surveillance support.' },
  { id: '11', name: 'Automotive', icon: 'Car', desc: 'ARAI, components, testing and model approval.' },
  { id: '12', name: 'Chemical', icon: 'FlaskRound', desc: 'BIS, PESO, DGFT and industrial compliance.' },
];

export const values = [
  { title: 'Values', icon: 'Gem', desc: 'Integrity, clarity and ownership shape every recommendation, document and deadline.' },
  { title: 'Promise', icon: 'Handshake', desc: 'Clear guidance and accountable support through every stage of the compliance lifecycle.' },
  { title: 'Mission', icon: 'Target', desc: 'Turn complex regulations into dependable market-access pathways for ambitious brands.' },
  { title: 'Vision', icon: 'Eye', desc: 'Make compliance a growth advantage and set a higher standard for regulatory execution.' },
];

export const journey = [
  { year: '2018', title: 'The beginning', desc: 'Started as a focused proprietorship with a clear purpose: simplify regulatory compliance for growing businesses.', tag: 'Foundation' },
  { year: '2019', title: 'Early market trust', desc: 'Built the first long-term client relationships through hands-on documentation and certification support.', tag: 'Momentum' },
  { year: '2020', title: 'Certification depth', desc: 'Strengthened execution across BIS, ISI, CRS and WPC with better testing and authority coordination.', tag: 'Core approvals' },
  { year: '2021', title: 'Multi-authority growth', desc: 'Expanded into LMPC, CDSCO, TEC and additional regulatory pathways for diverse product categories.', tag: 'Broader coverage' },
  { year: '2022', title: 'Private limited transition', desc: 'Transitioned from a proprietorship to a private limited company, formalising governance and delivery.', tag: 'Pvt. Ltd.' },
  { year: '2024', title: 'Managed compliance', desc: 'Introduced stronger tracking, renewal visibility, factory coordination and AMC-style management.', tag: 'Managed ops' },
  { year: '2026', title: 'Compliance infrastructure', desc: 'Evolving into an integrated market-access partner for Indian and international brands.', tag: 'Next chapter' },
];

export const countries = ['Canada', 'USA', 'Brazil', 'Kenya', 'Saudi', 'India', 'Russia', 'China', 'Taiwan'];

// Map coordinates [longitude, latitude]
export const countryMarkers = [
  { name: 'Canada',       coords: [-106.3, 56.1],  tag: 'North America \u00b7 CSA / FCC coordination' },
  { name: 'USA',          coords: [-95.7, 37.1],   tag: 'North America \u00b7 FCC / UL coordination' },
  { name: 'Brazil',       coords: [-51.9, -14.2],  tag: 'South America \u00b7 ANATEL support' },
  { name: 'Kenya',        coords: [37.9, -0.02],   tag: 'Africa \u00b7 KEBS coordination' },
  { name: 'Saudi Arabia', coords: [45.0, 23.9],    tag: 'MENA \u00b7 SASO / SABER' },
  { name: 'India',        coords: [78.9, 22.6],    tag: 'Home base \u00b7 BIS \u00b7 WPC \u00b7 TEC \u00b7 CDSCO', primary: true },
  { name: 'Russia',       coords: [105.3, 61.5],   tag: 'Eurasia \u00b7 EAC coordination' },
  { name: 'China',        coords: [104.2, 35.9],   tag: 'Asia \u00b7 CCC \u00b7 factory coordination' },
  { name: 'Taiwan',       coords: [120.9, 23.7],   tag: 'Asia \u00b7 BSMI \u00b7 NCC' },
];

export const testimonials = [
  { quote: 'Complise India brought structure to a complicated certification roadmap and helped our team move forward with confidence.', author: 'Global consumer brand', role: 'Consumer IoT' },
  { quote: 'The team handled documentation, testing coordination and regulatory follow-up with clear ownership.', author: 'Consumer electronics brand', role: 'D2C' },
  { quote: 'We needed long-term compliance support, not just one filing. Complise helped us create a cleaner operating system.', author: 'Importer network', role: 'Trading' },
  { quote: 'Factory audit preparation and renewal tracking became far easier once Complise started managing the workflow.', author: 'Manufacturing unit', role: 'OEM' },
  { quote: 'Their approval-route mapping saved us weeks of guesswork on our new device launch.', author: 'IoT startup', role: 'Founder' },
  { quote: 'A dependable partner across BIS, WPC and TEC when we scaled our imports.', author: 'D2C brand', role: 'Ops lead' },
];

export const serviceOptions = [
  'BIS / ISI Certification', 'BIS CRS Registration', 'Scheme-X Certification', 'BEE Certification',
  'WPC ETA Approval', 'TEC / MTCTE Certification', 'STQC Certification', 'Legal Metrology / LMPC',
  'CDSCO Medical Device', 'Cosmetic License', 'FSSAI Approval', 'TAC-IMEI Registration',
  'PESO Certification', 'DGFT Approval', 'ARAI Approval', 'AMC Compliance Management',
  'GeM Registration & Seller Support',
];

// Sub-services mapped per authority for the mega menu
export const subServices = {
  BIS: [
    { label: 'ISI Mark Certification (Scheme-1)', href: '/isi-mark-certification-scheme-1' },
    { label: 'CRS Certification', href: '/crs-certification' },
    { label: 'BIS Hallmark Registration', href: '/bis-hallmark-registration' },
    { label: 'BIS FMCS Certification', href: '/bis-fmcs-certification' },
  ],
  BEE: [
    { label: 'BEE Certification', href: '/bee-certification' },
    { label: 'Air Conditioners', href: '/bee-air-conditioners' },
    { label: 'Refrigerators', href: '/bee-refrigerators' },
    { label: 'LED Lamps', href: '/bee-led-lamps' },
    { label: 'Motors & Appliances', href: '/bee-motors' },
  ],
  WPC: [
    { label: 'WPC Approvals & Licences', href: '/wpc-approvals-and-licenses' },
    { label: 'Bluetooth Products', href: '/wpc-bluetooth-products' },
    { label: 'Wi-Fi Products', href: '/wpc-wi-fi-products' },
    { label: 'RF Modules', href: '/wpc-rf-modules' },
  ],
  TEC: [
    { label: 'TEC / MTCTE Certification', href: '/tec-mtcte-certification' },
    { label: 'MTCTE Certification', href: '/mtcte-certification' },
    { label: 'GR & IR Approval', href: '/gr-ir-approval' },
    { label: 'TSEC Certification', href: '/tsec-certification' },
    { label: 'NCCS (COMSEC)', href: '/nccs-comsec' },
  ],
  STQC: [
    { label: 'STQC Certification', href: '/stqc-certification' },
    { label: 'Biometric Devices', href: '/stqc-biometric-devices' },
    { label: 'Security Devices', href: '/stqc-security-devices' },
    { label: 'Smart Cards', href: '/stqc-smart-cards' },
  ],
  LMPC: [
    { label: 'Legal Metrology Compliance Services', href: '/legal-metrology-compliance-services' },
    { label: 'Legal Metrology Certification', href: '/legal-metrology-certification' },
    { label: 'LMPC Importer Registration', href: '/lmpc-lmpc-importer-registration' },
    { label: 'Manufacturer Registration', href: '/lmpc-manufacturer-registration' },
    { label: 'Packer Registration', href: '/lmpc-packer-registration' },
    { label: 'Label Compliance', href: '/lmpc-label-compliance' },
  ],
  CDSCO: [
    { label: 'Medical Device Registration', href: '/medical-device-registration' },
    { label: 'Medical Devices', href: '/cdsco-medical-devices' },
    { label: 'Import Route', href: '/cdsco-import-route' },
    { label: 'Cosmetics', href: '/cdsco-cosmetics' },
    { label: 'Manufacturing Route', href: '/cdsco-manufacturing-route' },
  ],
  FSSAI: [
    { label: 'FSSAI Approval', href: '/fssai-approval' },
    { label: 'Central Licence', href: '/fssai-central-license' },
    { label: 'State Licence', href: '/fssai-state-license' },
    { label: 'Product Approval', href: '/fssai-product-approval' },
    { label: 'Food Import Clearance', href: '/fssai-food-import-clearance' },
  ],
  DOT: [
    { label: 'TAC & IMEI Registration', href: '/tac-imei-registration' },
    { label: 'Mobile Phones', href: '/imei-mobile-phones' },
    { label: 'Imported Devices', href: '/imei-imported-devices' },
    { label: 'Cellular IoT Devices', href: '/imei-cellular-iot-devices' },
  ],
  PESO: [
    { label: 'PESO Certification', href: '/peso-certification' },
    { label: 'Petroleum Storage Licence', href: '/peso-petroleum-storage-license' },
    { label: 'Gas Cylinder Approval', href: '/peso-gas-cylinder-approval' },
    { label: 'Pressure Vessel Approval', href: '/peso-pressure-vessel-approval' },
  ],
  DGFT: [
    { label: 'DGFT Approval', href: '/dgft-approval' },
    { label: 'IEC Registration', href: '/iec-registration' },
    { label: 'SCOMET Registration', href: '/scomet-registration' },
    { label: 'Import Compliance', href: '/import-compliance' },
    { label: 'Export Documentation', href: '/export-documentation' },
  ],
  ARAI: [
    { label: 'ARAI Approval', href: '/arai-approval' },
    { label: 'Automotive Components', href: '/arai-automotive-components' },
    { label: 'Passenger Vehicles', href: '/arai-passenger-vehicles' },
    { label: 'Two Wheelers', href: '/arai-two-wheelers' },
    { label: 'Commercial Vehicles', href: '/arai-commercial-vehicles' },
  ],
  'B&L': [
    { label: 'Company Registration', href: '/company-registration-services' },
    { label: 'GST Registration', href: '/gst-registration' },
    { label: 'Taxation & Financial Compliance', href: '/taxation-financial-compliance' },
    { label: 'Intellectual Property', href: '/intellectual-property-services' },
    { label: 'Trademark Registration', href: '/trademark-registration' },
    { label: 'Import–Export Services', href: '/import-export-services' },
  ],
  GeM: [
    { label: 'GeM Registration & Account Setup', href: '/gem-registration#support' },
    { label: 'Vendor Assessment Support', href: '/gem-registration#support' },
    { label: 'Catalogue Management', href: '/gem-registration#support' },
    { label: 'Bid & Tender Management', href: '/gem-registration#process' },
    { label: 'Monthly Account Management', href: '/gem-registration#engagement-models' },
    { label: 'Reporting & Team Training', href: '/gem-registration#reporting' },
  ],
};

export const notifications = [
  {
    id: 1,
    title: 'BIS QCO update issued',
    desc: 'New Quality Control Order notified for smart wearables \u2014 mandatory from Oct 2026.',
    time: '2 hours ago',
    tag: 'BIS',
    unread: true,
  },
  {
    id: 2,
    title: 'WPC ETA fee revision',
    desc: 'WPC has revised ETA processing fees. Filings after 15 Sep follow the new schedule.',
    time: 'Yesterday',
    tag: 'WPC',
    unread: true,
  },
  {
    id: 3,
    title: 'CDSCO import portal maintenance',
    desc: 'SUGAM portal scheduled maintenance on Saturday 04:00\u201308:00 IST.',
    time: '2 days ago',
    tag: 'CDSCO',
    unread: false,
  },
  {
    id: 4,
    title: 'FSSAI renewal window opens',
    desc: 'Renewals for FY 2026\u201327 licences are now open. Early filing recommended.',
    time: '3 days ago',
    tag: 'FSSAI',
    unread: false,
  },
];

// Latest short news items for the top marquee bar
export const newsTicker = [
  { tag: 'NEW', text: 'Scheme-X for machinery products \u2014 phased QCO enforcement begins' },
  { tag: 'BIS', text: 'CRS list expanded \u2014 27 new electronic categories added under CRS' },
  { tag: 'WPC', text: 'ETA online filing turnaround reduced to 7 working days' },
  { tag: 'CDSCO', text: 'Class C & D medical device applications now fully digital' },
];
